import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserNotificationAction } from '@arc/arc-shared-frontend';
import { exhaustMap, of } from 'rxjs';
import {
  HostedPaymentsPadResultComponentPadActions,
  HostedPaymentsSelectPaymentMethodActions,
  HostedPaymentsSelectPaymentMethodPadAgreementActions,
  PoaPadResultComponentPadActions,
  PoaSelectPaymentMethodComponentActions,
  PoaSelectPaymentMethodPadAgreementActions,
  PoiPadResultComponentPadActions,
  PoiSelectPaymentMethodComponentActions,
  PoiSelectPaymentMethodPadAgreementActions,
} from '../component-actions';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PadAgreementEffects {
  constructor(
    private actions$: Actions,
    private translate: TranslateService,
  ) {}

  getPadVerificationStatusError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiSelectPaymentMethodPadAgreementActions.padVerificationError,
        PoaSelectPaymentMethodPadAgreementActions.padVerificationError,
        PoaPadResultComponentPadActions.padVerificationError,
        HostedPaymentsPadResultComponentPadActions.padVerificationError,
        PoiPadResultComponentPadActions.padVerificationError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_GET_PAD_VERIFICATION_STATUS_ERROR',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayPadTwikeyRedirectError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiSelectPaymentMethodPadAgreementActions.createTwikeyInviteError,
        PoaSelectPaymentMethodPadAgreementActions.createTwikeyInviteError,
        HostedPaymentsSelectPaymentMethodPadAgreementActions.createTwikeyInviteError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_PAD_REDIRECT_ERROR',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayUpdatePadVerifiedStatusError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusError,
        PoaSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusError,
        HostedPaymentsSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_UPDATE_PAD_VERIFIED_STATUS_ERROR',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayTwikeyStatusNotOkError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiSelectPaymentMethodComponentActions.twikeySignatureFailed,
        HostedPaymentsSelectPaymentMethodActions.twikeySignatureFailed,
        PoaSelectPaymentMethodComponentActions.twikeySignatureFailed,
      ),
      exhaustMap((action) =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_PAD_TWIKEY_STATUS_IS_NOT_OK',
              { displayName: action.payload.paymentMethodDisplayName },
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayLoadPreAuthorizedDebitModeError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiPadResultComponentPadActions.loadPreAuthorizedDebitModeError,
        PoaPadResultComponentPadActions.loadPreAuthorizedDebitModeError,
        HostedPaymentsPadResultComponentPadActions.loadPreAuthorizedDebitModeError,
      ),
      exhaustMap(() =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              'ARC_PAYMENT_FAILED_TO_LOAD_PAD_MODE',
            ) as string,
          }),
        ),
      ),
    ),
  );

  displayCompleteTwikeyInviteError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        PoiPadResultComponentPadActions.completeTwikeyInviteError,
        PoaPadResultComponentPadActions.completeTwikeyInviteError,
        HostedPaymentsPadResultComponentPadActions.completeTwikeyInviteError,
      ),
      exhaustMap((action) =>
        of(
          new UserNotificationAction({
            type: 'error',
            message: this.translate.instant(
              action.message ?? 'ARC_PAYMENT_FAILED_TO_COMPLETE_PAD_AGREEMENT',
            ) as string,
          }),
        ),
      ),
    ),
  );
}
